import { Route, Routes } from "react-router-dom";
import React from "react";
import { PropertySummaryList } from "./PropertySummaryList";

export const PropertySummaryRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="*" element={<PropertySummaryList />} />
    </Routes>
  );
};
